module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAClSURBVHgB7ZXbDUBAEEVvRAHbASXogBJ0QglKoAI1qEAJlKADJTATJPuB2Ud82ZPciORmTmxkFnimoqyUzSE9Rb3MRuk4WE/Dg+IHQXY+B0oNO7jPX5+/CS74iBbYMesvET4mCIIgCP4sUBDWsY8gpUw4FmEplV0E6pQwhVSW1vUdvI47SkJppbKLgDG+hCSBfhymJCalAv53ci9JGo/hIwx/Y292espKnGJSqOkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/sparker/icon-phone.png
// module id = Za1c
// module chunks = 0